/* eslint-disable no-useless-escape */
import { useState, useEffect } from "react"
import { Helmet } from "react-helmet-async"
import InputText from "../../../components/inputText/InputText"
import TextArea from "../../../components/textArea/TextArea"
import Button from "../../../components/button/Button"
import Modal from "../../../components/modal/Modal"
import Loader from "../../../components/modal/Loader"
import Select from "../../../components/select/Select"
import InputFile from "../../../components/inputFile/InputFile"
import {Form} from "semantic-ui-react"
import { useForm } from "react-hook-form"
import { useNavigate } from "react-router-dom"
import { isBrowser, getToken } from "../../../services/auth"
import MarkdownEditor from "../../../components/markdownEditor/MarkdownEditor"
import { config } from '../../../config/env';

const AddResearchPaper = () => {
    const navigate = useNavigate()
    const {
        register,
        handleSubmit,
        formState: { errors },
        setValue,
        getValues,
    } = useForm({
        mode: "onBlur"
    });

    const [isLoading, setIsLoading] = useState(false)
    const [showModal, setShowModal] = useState(false)
    const [modalMode, setModalMode] = useState("confirm");
    const [modalTitle, setModalTitle] = useState("")
    const [modalSubText, setModalSubText] = useState("")
    const [modalIcon, setModalIcon] = useState("success")
    const [confirmButtonText, setConfirmButtonText] = useState("")
    const [confirmButtonAction, setConfirmButtonAction] = useState(null)
    const [topics, setTopics] = useState([])
    const [topicError, setTopicError] = useState("")
    const [previewMarkdown, setPreviewMarkdown] = useState(false)
    const [images, setImages] = useState([])

    const addSuccessHandler = () => () => {
        navigate("/ava-admin/researchpapers") 
    }

    const onSubmit = async (statusId) => {
        setIsLoading(true);

        let newResearchPaper = {
            "title": getValues("name"),
            "description": getValues("description"),
            "author": getValues("author"),
            "content": getValues("content"),
            "documentation_url": getValues("documentation_url"),
            "repository_url": getValues("repository_url"),
            "preview_image_filename": getValues("preview_image_filename"),
            "banner_image_filename": getValues("banner_image_filename"),
            "topic_id": getValues("topic_id"),
            "content_status_id": statusId,
            "image_filenames": getValues("image_filenames") || [],
            "published_at": getValues("published_at")
        }

        const uploadImage = async (formData) => {
                try {
                    const response = await fetch(`${config.apiBaseUrl}/api/v1/admin/files/`, {
                        method: "POST",
                        body: formData,
                        headers: {
                            "Authorization": `Bearer ${await getToken()}`
                        }
                    })
                    const data = await response.json()
                    if (response.status === 200) {
                        console.log("Data from executing uploadImage")
                        return data
                    }
                } catch (error) {
                    console.error('Error uploading image:', error)
                }
            }
        
        let preview_image_file = getValues("preview_image_file")
        if(preview_image_file && preview_image_file.length > 0) {
            let formData = new FormData()
            formData.append("file", preview_image_file[0])
            formData.append("file_type", 1)

            const data = await uploadImage(formData)
            if (data && data.filename) {
                newResearchPaper.preview_image_filename = data.filename
            }
        }

        let banner_image_file = getValues("banner_image_file")
        if(banner_image_file && banner_image_file.length > 0) {
            let formData = new FormData()
            formData.append("file", banner_image_file[0])
            formData.append("file_type", 1)

            const data = await uploadImage(formData)
            if (data && data.filename) {
                newResearchPaper.banner_image_filename = data.filename
            }
        }

        if (isBrowser()) {
            fetch(`${config.apiBaseUrl}/api/v1/admin/content/research_papers/`, {
                method: "POST",
                headers: { 
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${await getToken()}`
                },
                body: JSON.stringify(newResearchPaper) 
            })
            .then(async (response) => {
                setModalMode("feedback");
                if (response.status === 200) {
                    setModalIcon("success")
                    setModalTitle("Successful")
                    setModalSubText("Research paper was added successfully.")
                    setConfirmButtonText("Go to research papers")
                    setConfirmButtonAction(addSuccessHandler);
                } else {
                    let errorMessage = "Something went wrong.";
                    try {
                        const errorData = await response.json();
                        errorMessage = errorData?.message || JSON.stringify(errorData);
                        } catch (jsonErr) {
                        try {
                            errorMessage = await response.text();
                        } catch (textErr) {
                            errorMessage = "Unable to read error message.";
                        }
                    }
            setModalMode("feedback");
            setModalIcon("error");
            setModalTitle("Error");
            setModalSubText(errorMessage);
            setConfirmButtonText("Close");
            setConfirmButtonAction(() => () => resetModal());
        }
            })
            .catch(error => {
              setModalMode("feedback"); 
              setModalIcon("error");
              setModalTitle("Error");
              setModalSubText(error.toString());
              setConfirmButtonText("Close");
              setConfirmButtonAction(() => () => resetModal());
            })
            .finally(() => {
              setIsLoading(false);
              setShowModal(true);
            })
        }
    }

    const resetModal = () => {
      setShowModal(false);
      setConfirmButtonAction(null);
      setModalMode("confirm");
  };


    useEffect(() => {
        setIsLoading(true)
        register("topic_id", { required: true, validate: validateTopicId })
        const fetchTopics = async () => {
            try {
                const response = await fetch(`${config.apiBaseUrl}/api/v1/admin/topics/`, {
                    method: "GET",
                    headers: {
                      "Access-Control-Allow-Origin": "*",
                      "Content-Type": "application/json",
                      "Authorization": `Bearer ${await getToken()}`
                    },
                  })
                const data = await response.json()
                setTopics([{id:0,name:'Select topic', disabled: true},...data.data])
                setIsLoading(false)
            } catch (error) {
                console.error('Error fetching topics:', error)
            }
        }
        fetchTopics()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const topicChangeHandler = (topic) => {
        setValue("topic_id", topic.id)
    }

    const validateTopicId = (value) => {
        if (value === 0) {
            setTopicError("Please select a topic")
            return "Please select a topic"
        }
        setTopicError("")
        return true
    }

    const cancelHandler = () => {
        navigate(-1)
    }

    return (
        <>
            <Helmet>
                <title>Avanade Research - Admin</title>
            </Helmet>
            <div page="researchpapers"> 
                <div className="w-[calc(100%-40px)] min-h-[calc(100%-40px)] m-[20px] bg-white rounded-2xl p-10 shadow-lg text-sm">
                    <div className="max-w-[1280px] mx-auto">
                        <div className="flex w-full">
                            <div className="block w-full">
                                <div className="text-lg font-semibold">Add Research Paper</div>
                                <div className="text-gray-600">Add an article written by researchers to present the results of studies and experiments.</div>
                            </div>
                        </div>

                        <div className="mt-10">
                            {/*form add new topic */}
                            <Form className="w-full">
                                <Form.Field>
                                    <div className="mt-3 flex">
                                        {topics.length > 0 && (
                                            <div className="w-[50%] mr-8">
                                                <Select 
                                                    items={topics}
                                                    label="Topic"
                                                    itemChangeHandler={topicChangeHandler}
                                                    error={topicError} />
                                            </div>
                                        )}
                                        <div className="w-[50%]">
                                            <InputFile accept="image/*" script={register("preview_image_file", { required: true })} label="Preview Image" error={errors.preview_image_file ? "Upload a preview image" : ""}/>
                                        </div>
                                    </div>
                                    <div className="mt-3 flex">
                                        <div className="w-[50%] mr-8">
                                            <InputText type="text" label="Title"
                                                id="title" script={register("name", { required: true } )} 
                                                error={errors.name ? 'Title is required': ''}/> 
                                        </div>
                                        <div className="w-[50%]">
                                            <InputFile accept="image/*" script={register("banner_image_file", { required: false })} label="Banner Image" error={errors.banner_image_file ? "Upload a banner image" : ""}/>
                                        </div>
                                    </div>
                                    <div className="mt-3 flex">
                                        <div className="w-[50%] mr-8">
                                            <InputText label="Author" type="text"
                                                    id="author" script={register("author", { required: true } )} 
                                                    error={errors.author ? 'Author is required': ''}/>
                                        </div>
                                        <div className="w-[50%]">
                                            <InputText label="Documentation URL" type="text"
                                                id="documentation_url" script={register("documentation_url", { required: true, pattern:{value: /^(https?:\/\/)[\w\-]+(\.[\w\-]+)+([\/?#].*)?$/, message: "Use the correct URL format (e.g: https://www.sample.com or http://www.sample.com)"}})} 
                                                error={errors.documentation_url ? errors.documentation_url.type === "pattern"
                                                            ? "Use the correct URL format (e.g: https://www.sample.com or http://www.sample.com)"
                                                            : "Documentation URL is required" : ""}
                                            />
                                        </div>
                                    </div>
                                    <div className="mt-3 flex">
                                        <div className="w-[50%] mr-8">
                                            <InputText type="date" label="Published Date"
                                                id="published_at" script={register("published_at", { required: true } )} 
                                                error={errors.published_at ? 'Published Date is required': ''}/> 
                                        </div>
                                        <div className="w-[50%]">
                                            <InputText label="Repository URL" type="text"
                                                    id="repository_url" script={register("repository_url", { required: true, pattern:{value: /^(https?:\/\/)[\w\-]+(\.[\w\-]+)+([\/?#].*)?$/, message: "Use the correct URL format (e.g: https://www.sample.com or http://www.sample.com)"}})}
                                                    error={errors.repository_url ? errors.repository_url.type === "pattern"
                                                            ? "Use the correct URL format (e.g: https://www.sample.com or http://www.sample.com)"
                                                            : "Repository URL is required" : ""}
                                            />
                                        </div>
                                    </div>
                                    <div className="mt-5">
                                        <TextArea label="Description" type="text"
                                            id="description" script={register("description", { required: false } )} 
                                            rows="3" error={errors.description ? 'Description is required': ''}/>
                                    </div>
                                    <MarkdownEditor 
                                        images={images} setImages={setImages}
                                        isLoading={isLoading} setIsLoading={setIsLoading}
                                        getValues={getValues} setValue={setValue}
                                        previewMarkdown={previewMarkdown} setPreviewMarkdown={setPreviewMarkdown}
                                        register={register} errors={errors}
                                    />
                                </Form.Field>
                                <div className="flex justify-end mt-7">
                                    <Button type="button" label="Cancel" color="gray-200" text="gray-800"
                                        onClick={cancelHandler} />
                                    <Button type="submit" label="Save as draft" color="gray-200" text="gray-800" className="ml-4"
                                        onClick={handleSubmit(() => onSubmit(1))} />
                                    <Button type="submit" label="Submit" className="ml-4"
                                        onClick={handleSubmit(() => onSubmit(2))} />
                                </div>
                            </Form>

                            {/* Show leader when isLoading is true */}
                            {isLoading && <Loader />}

                            {/* Modal */}
                            {showModal && (
                                <Modal 
                                    title={modalTitle}
                                    subtext={modalSubText}
                                    cancelButton={modalMode === "confirm"}
                                    confirmButtonText={confirmButtonText}
                                    confirmButtonAction={confirmButtonAction}
                                    icon={modalIcon}
                                    onCancel={resetModal}/>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AddResearchPaper